// HomePage.js
import React, { useState, useEffect } from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import styles from './HomePage.module.scss';

const testimonies = [
  { text: "Amazing products! The quality is unmatched.", author: "John Doe" },
  { text: "I love shopping at Ultimate Sport Store. They have everything I need.", author: "Jane Smith" },
  // Add more testimonies as needed
];
const AboutUsSection = () => (
  <section className={styles.aboutUs}>
    <h2>About Us</h2>
    <div className={styles.aboutUsContent}>
      <p>
        Welcome to Ultimate Sport Store – your premier destination for top-quality sports equipment. We take pride in offering a diverse range of high-quality products, including cricket bats, balls, shoes, and more.
      </p>
      <p>
        At Ultimate Sport Store, we are passionate about providing the latest generation sports gear that meets the highest standards of performance. Whether you're a cricket enthusiast or a sports aficionado, our curated selection ensures you have access to the best equipment available in the market.
      </p>
      <p>
        Our commitment to excellence extends beyond our products. We prioritize customer satisfaction and aim to create a seamless shopping experience for every sports enthusiast. Explore our store and discover the perfect gear to elevate your game to new heights.
      </p>
    </div>
  </section>
);




const ShopByBrandSection = () => (
  <section className={styles.shopByBrand}>
    <h2>Shop by Brand</h2>
    <div className={styles.brandList}>
      <div className={styles.brandCard}>
        <img src="https://pbs.twimg.com/profile_images/1435836090502443025/0xImFYim_400x400.jpg" alt="Brand Logo 1" />
        <p>Brand Name 1</p>
      </div>
      <div className={styles.brandCard}>
        <img src="data:image/png;base64,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" alt="Brand Logo 2" />
        <p>Brand Name 2</p>
      </div>
      <div className={styles.brandCard}>
        <img src="https://via.placeholder.com/100" alt="Brand Logo 2" />
        <p>Brand Name 2</p>
      </div>
      <div className={styles.brandCard}>
        <img src="https://via.placeholder.com/100" alt="Brand Logo 2" />
        <p>Brand Name 2</p>
      </div>
      <div className={styles.brandCard}>
        <img src="https://via.placeholder.com/100" alt="Brand Logo 2" />
        <p>Brand Name 2</p>
      </div>
      {/* Add more brand cards as needed */}
    </div>
  </section>
);

const HomePage = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex(prevIndex => (prevIndex + 1) % testimonies.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className={styles.container}>
      <section className={styles.hero}>
        <h1 className={styles.companyName}>Ultimate Sport Store</h1>
        <div className={styles.welcomeMessage}>
          <p>Welcome to our premium sports store located in Newark, NJ. Explore our collection of top-quality athletic gear.</p>
        </div>
        <a href="#featured-products" className={styles.btn}>Shop Now</a>
        <AboutUsSection />
       
      </section>

      <section id="featured-products" className={styles.featuredProducts}>
        <h2>Featured Products</h2>
        <Carousel showArrows={false} showStatus={false} showIndicators={false} infiniteLoop autoPlay interval={5000}>
          <div className={styles.productCard}>
            <img src="https://via.placeholder.com/300" alt="Football" />
            <h3>Football</h3>
            <p>High-quality football for professional play.</p>
            <a href="#">View Product</a>
          </div>
          <div className={styles.productCard}>
            <img src="https://via.placeholder.com/300" alt="Football" />
            <h3>Football</h3>
            <p>High-quality football for professional play.</p>
            <a href="#">View Product</a>
          </div>
          <div className={styles.productCard}>
            <img src="https://via.placeholder.com/300" alt="Football" />
            <h3>Football</h3>
            <p>High-quality football for professional play.</p>
            <a href="#">View Product</a>
          </div>
          <div className={styles.productCard}>
            <img src="https://via.placeholder.com/300" alt="Football" />
            <h3>Football</h3>
            <p>High-quality football for professional play.</p>
            <a href="#">View Product</a>
          </div>
          <div className={styles.productCard}>
            <img src="https://via.placeholder.com/300" alt="Football" />
            <h3>Football</h3>
            <p>High-quality football for professional play.</p>
            <a href="#">View Product</a>
          </div>
          {/* Add more carousel items as needed */}
        </Carousel>
      </section>
      <ShopByBrandSection/>
      
      
    


      
 

      <section className={styles.videos}>
        <h2>Featured Videos</h2>
        <div className={styles.videoCarousel}>
          <div className={styles.videoCard}>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/dQw4w9WgXcQ" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            <div className={styles.videoDescription}>
              <h3>Video Title</h3>
              <p>Description of the video goes here.</p>
            </div>
            
          </div>
          <div className={styles.videoCard}>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/dQw4w9WgXcQ" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            <div className={styles.videoDescription}>
              <h3>Video Title</h3>
              <p>Description of the video goes here.</p>
            </div>
            
          </div>
          <div className={styles.videoCard}>
            <iframe width="560" height="315" src="https://www.youtube.com/embed/dQw4w9WgXcQ" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
            <div className={styles.videoDescription}>
              <h3>Video Title</h3>
              <p>Description of the video goes here.</p>
            </div>
            
          </div>
          
          {/* Add more videos as needed */}
        </div>
        
      </section>
    </div>
  );
}

export default HomePage;
